<template>
  <button class="bg-blue-700 hover:bg-blue-400 text-white font-bold py-2 px-4 rounded inline-flex items-center uppercase">
    <slot></slot>
  </button>
</template>
